'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['message', 'mobileVersion'],
    computed: {
        avatarClass: function avatarClass() {
            var platformClass = this.mobileVersion === 'true' ? 'kiwi-messagelist-avatar-mobile ' : 'kiwi-messagelist-avatar-desktop ';

            if (!this.message.user.gender || !this.message.user.targetGender) {
                return platformClass + "kiwi-avatar--default";
            }
            var avatar = this.message.user.gender.charAt(0) + this.message.user.targetGender.charAt(0);
            if (["mm", "mw", "mo", "mt", "fw", "fm", "fo", "ft", "om", "ow", "ot", "oo", "tm", "tw", "to", "tt"].includes(avatar)) {
                return platformClass + "kiwi-avatar--" + avatar;
            }
            return platformClass + "kiwi-avatar--default";
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/MessageListAvatar.vue
// module id = 7Bxd
// module chunks = 1